import Vue from 'vue'
import Chroma from 'chroma-js'
import gsap from 'gsap'
import { CSSRulePlugin } from 'gsap/CSSRulePlugin'
import { watch } from '@vue/composition-api'
import { theme } from '@iez/core'
import { addThemeChangeTrigger } from '@iez/core/theme/'

gsap.registerPlugin(CSSRulePlugin)

function getInheritedBackgroundColor (el) {
  // get default style for current browser
  var defaultStyle = getDefaultBackground() // typically "rgba(0, 0, 0, 0)"

  // get computed color for el
  var backgroundColor = window.getComputedStyle(el).backgroundColor

  // if we got a real value, return it
  if (backgroundColor != defaultStyle) return backgroundColor

  // if we've reached the top parent el without getting an explicit color, return default
  if (!el.parentElement) return defaultStyle

  // otherwise, recurse and try again on parent element
  return getInheritedBackgroundColor(el.parentElement)
}

function getDefaultBackground () {
  // have to add to the document in order to use getComputedStyle
  var div = document.createElement("div")
  document.head.appendChild(div)
  var bg = window.getComputedStyle(div).backgroundColor
  document.head.removeChild(div)
  return bg
}

const isInDocument = ({ element }) =>
  document.body.contains(element)

export default {
  setup: () => {
    Vue.directive(`glass`, {
      inserted: async (element, { value }) => {
        return
        const process = async () => {
          console.log('processing')
          const {
            alphaValue,
            root,
            blur
          } = typeof value === `number`
              ? {
                alphaValue: value,
                blur: 4,
                root: false
              } : {
                alphaValue: value.alphaValue,
                blur: value.blur ?? 4,
                root: value.root
              }
  
          await new Promise(resolve => requestAnimationFrame(resolve))
  
          if (!isInDocument({ element })) {
            return
          }
  
          const apply = ({ element }) => {
            const {
              color
            } = getComputedStyle(element)
            const chromaColor = Chroma(color)
            const invertedColor = chromaColor
              .set(`hsl.l`, 1 - chromaColor.get(`hsl.l`))
            const backgroundColor = getInheritedBackgroundColor(element)
            const chroma = Chroma(backgroundColor).alpha(alphaValue)
            const backgroundColorWithAlpha = chroma.hex()
            const invertedBackgroundColorWithAlpha =
              chroma
                .set(`hsl.l`, 1 - chroma.get(`hsl.l`))
                .hex()
  
            gsap.set(
              element, {
                backdropFilter: `blur(${blur}px)`
              }
            )
            element.classList.remove(`primary`)
  
            const { dark: firstDarkValue } = theme
            watch(
              () => theme.dark,
              dark => {
                if (dark !== firstDarkValue) {
                  gsap.set(
                    element, {
                      backgroundColor: invertedBackgroundColorWithAlpha,
                      color: invertedColor
                    }
                  )
                } else {
                  gsap.set(
                    element, {
                      backgroundColor: backgroundColorWithAlpha,
                      color
                    }
                  )
                }
              }, {
              immediate: true
            }
            )
          }
          if (root) {
            const findToApply = ({ element }) => {
              if (element.hasAttribute(`data-glass`)) {
                apply({ element })
              } else {
                Array.from(element.children)
                  .forEach(child => {
                    findToApply({ element: child })
                  })
              }
            }
            findToApply({ element })
            gsap.set(element, {
              backgroundColor: `transparent`,
              backdropFilter: `blur(${blur}px)`
            })
          } else {
            apply({ element })
          }
        }
        process()
        addThemeChangeTrigger(
          () => {
            setTimeout(process, 500)
          }
        )
      }
    })
  }
}
